import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import PageShare from './pages/PageShare.jsx';
import PageShares from './pages/PageShares.jsx';

const App = () => (
    <Router>
        <div className="w-100">
          <Switch>
            <Route exact path="/shares">
              <PageShares />
            </Route>
            <Route exact path="/shares/:_id">
              <PageShare />
            </Route>
          </Switch>
        </div>
    </Router>
);

export default App;
